import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Placeholder trigger form rendered when no specific form has been
 * registered for a flow's entry_event_type yet. Emits a generic config
 * object; real per-trigger forms (geofence, beacon, follow-up, signal,
 * manual, etc.) will replace this in future sessions via the
 * `triggerFormRegistry`.
 */
@Component({
  selector: "app-default-trigger-form",
  template: `
    <div class="default-trigger-form">
      <p class="description">
        A dedicated form for
        <strong>{{ entryEventType || "this trigger" }}</strong>
        has not been registered yet. The test will run with the generic
        config below. Use the Advanced JSON field to pass custom values.
      </p>

      <div class="field">
        <label>Notes</label>
        <textarea
          [value]="config.notes || ''"
          (input)="updateField('notes', $any($event.target).value)"
          rows="2"
          placeholder="Optional notes shown on the test detail view"
        ></textarea>
      </div>

      <div class="field">
        <label>Advanced Config (JSON)</label>
        <textarea
          [value]="advancedJson"
          (input)="updateJson($any($event.target).value)"
          rows="6"
          placeholder="{}"
          [class.invalid]="!advancedJsonValid"
        ></textarea>
        <div class="hint" *ngIf="!advancedJsonValid">Invalid JSON</div>
      </div>
    </div>
  `,
  styles: [
    `
      .default-trigger-form {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      .field {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      label {
        font-weight: 600;
      }
      textarea {
        font-family: inherit;
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
      }
      textarea.invalid {
        border-color: #c0392b;
      }
      .description {
        color: #666;
        margin: 0;
      }
      .hint {
        color: #c0392b;
        font-size: 12px;
      }
    `,
  ],
})
export class DefaultTriggerFormComponent {
  @Input() entryEventType: string | null = null;

  config: Record<string, any> = {};
  advancedJson = "{}";
  advancedJsonValid = true;

  @Output() configChange = new EventEmitter<Record<string, any>>();

  updateField(key: string, value: any) {
    this.config = { ...this.config, [key]: value };
    this.emit();
  }

  updateJson(value: string) {
    this.advancedJson = value;
    try {
      const parsed = value.trim() === "" ? {} : JSON.parse(value);
      this.advancedJsonValid = true;
      this.config = { ...this.config, ...(parsed || {}) };
      this.emit();
    } catch (_e) {
      this.advancedJsonValid = false;
    }
  }

  private emit() {
    this.configChange.emit(this.config);
  }
}
